import React, { useContext, useState, useEffect } from 'react';
import Card from "@material-tailwind/react/Card";
import CardHeader from "@material-tailwind/react/CardHeader";
import CardBody from "@material-tailwind/react/CardBody";
import { RootContext } from '../../App';
import axiosInstance from '../../config/axios';
import refactorStructureData from '../../helpers/refactorDataMenu';
import DataTable from 'react-data-table-component';
import Button from "@material-tailwind/react/Button";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Input from "@material-tailwind/react/Input";
import Swal from 'sweetalert2';
import Icon from "@material-tailwind/react/Icon";

export default function ReferralExcludeList() {
  const token = localStorage.getItem("access_token");
  const group = JSON.parse(localStorage.getItem("group"));
  const [data, setData] = useState([]);
  const { state, setState } = useContext(RootContext);
  const [isLoading, setIsLoading] = useState(true);
  const [length, setLength] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [playerName, setPlayerName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchData = () => {
    setIsLoading(true);
    
    axiosInstance.post('list_excluded_players', {
      token: token,
      group: group.wbid,
      lgth: length
    }).then((res) => {
      setIsLoading(false);
      setData(res.data.data.list);
      setState({
        ...state,
        group: res.data.data.additional_data.group,
        menu: refactorStructureData(res.data.data.additional_data.menu),
      });
    }).catch((err) => {
      console.log(err);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [length]);

  const handleAddPlayer = () => {
    if (!playerName.trim()) {
      Swal.fire('Error', 'Player name cannot be empty', 'error');
      return;
    }

    setIsSubmitting(true);
    
    axiosInstance.post('add_excluded_player', {
      token: token,
      group: group.wbid,
      user: playerName
    }).then((res) => {
      setIsSubmitting(false);
      setShowModal(false);
      setPlayerName("");
      
      if (res.data.code === 0) {
        Swal.fire('Success', 'Player has been added to exclusion list', 'success');
        fetchData(); // Refresh the data
      } else {
        Swal.fire('Error', res.data.message || 'Failed to add player', 'error');
      }
    }).catch((err) => {
      console.log(err);
      setIsSubmitting(false);
      Swal.fire('Error', err.response?.data?.message || 'Something went wrong', 'error');
    });
  };

  const handleDeletePlayer = (username) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to remove ${username} from the exclusion list?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        axiosInstance.post('delete_excluded_player', {
          token: token,
          group: group.wbid,
          user: username
        }).then((res) => {
          if (res.data.code === 0) {
            Swal.fire(
              'Deleted!',
              'Player has been removed from exclusion list.',
              'success'
            );
            fetchData(); // Refresh the data
          } else {
            Swal.fire(
              'Error',
              res.data.message || 'Failed to delete player',
              'error'
            );
          }
        }).catch((err) => {
          console.log(err);
          Swal.fire(
            'Error',
            err.response?.data?.message || 'Something went wrong',
            'error'
          );
        });
      }
    });
  };

  const columns = [
    {
      name: '#',
      selector: (row, index) => index + 1,
      sortable: true,
      width: '80px'
    },
    {
      name: 'Player ID',
      selector: row => row.username,
      sortable: true,
    },
    {
      name: 'Created At',
      selector: row => {
        const date = new Date(row.created_at);
        const dateOptions = { day: '2-digit', month: 'short', year: 'numeric' };
        const timeOptions = { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false };
        const formattedDate = date.toLocaleDateString('en-GB', dateOptions);
        const formattedTime = date.toLocaleTimeString('en-GB', timeOptions);
        return `${formattedDate} ${formattedTime}`;
      },
      sortable: true,
    },
    {
      name: 'Action',
      cell: (row) => (
        <div className="flex">
          <Button
            color="red"
            buttonType="link"
            size="sm"
            rounded={true}
            iconOnly={true}
            ripple="dark"
            onClick={() => handleDeletePlayer(row.username)}
          >
            <Icon name="delete" size="sm" />
          </Button>
        </div>
      ),
      width: '150px'
    },
  ];

  return (
    <div>
      <div className="bg-light-blue-500 pt-7 pb-28 px-3 md:px-8 h-auto"></div>
      <div className="px-3 md:px-8 h-auto -mt-24">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4 mb-16">
            <Card>
              <CardHeader color="blueGray" contentPosition="between">
                <h2 className="text-white text-2xl">Excluded Referral Players</h2>
              </CardHeader>
              <CardBody>
                <div className="mb-4 flex justify-end">
                  <Button
                    color="lightBlue"
                    buttonType="filled"
                    size="regular"
                    rounded={false}
                    block={false}
                    iconOnly={false}
                    ripple="light"
                    onClick={() => setShowModal(true)}
                  >
                    Add Player
                  </Button>
                </div>
                <DataTable
                  columns={columns}
                  data={data}
                  progressPending={isLoading}
                  pagination
                  paginationServer
                  onChangeRowsPerPage={(currentRowsPerPage) => {
                    setLength(currentRowsPerPage);
                  }}
                  paginationRowsPerPageOptions={[10, 50, 100, 500]}
                />
              </CardBody>
            </Card>
          </div>
        </div>
      </div>

      {/* Add Player Modal */}
      <Modal size="sm" active={showModal} toggler={() => setShowModal(false)}>
        <ModalHeader toggler={() => setShowModal(false)}>
          Add Exclusion
        </ModalHeader>
        <ModalBody>
          <div className="mt-4 mb-8">
            <Input
              type="text"
              color="lightBlue"
              size="regular"
              outline={true}
              placeholder="Player Name"
              value={playerName}
              onChange={(e) => setPlayerName(e.target.value)}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="red"
            buttonType="link"
            onClick={() => setShowModal(false)}
            ripple="dark"
          >
            Cancel
          </Button>
          <Button
            color="green"
            onClick={handleAddPlayer}
            ripple="light"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Add Player"}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}